export const CREATE_RING_GROUP_MEMBER_START = 'CREATE_RING_GROUP_MEMBER_START';
export const CREATE_RING_GROUP_MEMBER_SUCCESS = 'CREATE_RING_GROUP_MEMBER_SUCCESS';
export const CREATE_RING_GROUP_MEMBER_ERROR = 'CREATE_RING_GROUP_MEMBER_ERROR';
export const DELETE_RING_GROUP_MEMBER_START = 'DELETE_RING_GROUP_MEMBER_START';
export const DELETE_RING_GROUP_MEMBER_SUCCESS = 'DELETE_RING_GROUP_MEMBER_SUCCESS';
export const DELETE_RING_GROUP_MEMBER_ERROR = 'DELETE_RING_GROUP_MEMBER_ERROR';